import { render, staticRenderFns } from "./DealTab.vue?vue&type=template&id=21b95897&scoped=true&lang=pug&"
import script from "./DealTab.vue?vue&type=script&lang=js&"
export * from "./DealTab.vue?vue&type=script&lang=js&"
import style0 from "./DealTab.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./DealTab.vue?vue&type=style&index=1&id=21b95897&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b95897",
  null
  
)

export default component.exports